import { useEffectiveFilters } from '../../../filters/hooks/useEffectiveFilters';
import { FilterType, type TreeSelection } from '../../../filters/types/filters';
import { pageFilterSelections } from '../../DataProvider/composition/taxonomy-icicle/plan-taxonomy-icicle-requests';
import { ICICLE_TAXONOMIES } from '../../DataProvider/composition/taxonomy-icicle/taxonomies/taxonomy-registry';
import type { IcicleTaxonomySegment } from '../../DataProvider/composition/taxonomy-icicle/taxonomies/types';
import { useTaxonomyIcicleSourceKey } from '../../DataProvider/composition/taxonomy-icicle/use-taxonomy-icicle-tree';
import { usePageState } from '../../PageState/PageStateProvider';
import { useChart } from '../ChartProvider';

export const useIcicleChips = (): readonly TreeSelection[] => {
  const { item } = useChart();
  const { pageState } = usePageState();
  const effectiveFilters = useEffectiveFilters();
  const primaryFilter = effectiveFilters.find((filter) => filter.isPrimary);
  if (primaryFilter?.type !== FilterType.TREE) return [];
  const selections = primaryFilter.primarySelections?.length
    ? primaryFilter.primarySelections
    : primaryFilter.selections;
  const pickedEntity = item?.plot?.isSingleEntity
    ? pageState.primaryEntities?.[item.id]
    : undefined;
  return selections.length > 1 && item?.plot?.isSingleEntity
    ? selections.filter(
        (selection) =>
          pickedEntity !== undefined &&
          selection.levelId === pickedEntity.levelId &&
          (selection.id.split('_').pop() || selection.id) === pickedEntity.id
      )
    : selections;
};

export const useIcicleChartKey = (
  segment: IcicleTaxonomySegment,
  chips: readonly TreeSelection[]
): string => {
  const taxonomy = ICICLE_TAXONOMIES[segment];
  const sourceKey = useTaxonomyIcicleSourceKey(taxonomy);
  const effectiveFilters = useEffectiveFilters();
  const scopeKey = pageFilterSelections(effectiveFilters, taxonomy.filterId)
    .map(({ levelId, id }) => `${levelId}:${id}`)
    .join(',');
  const chipsKey = chips.map((chip) => `${chip.levelId}:${chip.id}`).join(',');
  return [segment, sourceKey, scopeKey, chipsKey].join('|');
};
